import React from 'react';

import { onboardColors } from '../../theme/onboardTokens';
import { font, palette } from '../styles';

type Variant = 'warning' | 'primary' | 'neutral' | 'icon';

interface Props {
  label?: string;
  icon?: React.ReactNode;
  variant?: Variant;
  disabled?: boolean;
  onClick?: () => void;
  title?: string;
  type?: 'button' | 'submit';
  style?: React.CSSProperties;
}

const ActionButton: React.FC<Props> = ({
  label,
  icon,
  variant = 'warning',
  disabled,
  onClick,
  title,
  type = 'button',
  style
}) => {
  const palettes: Record<Variant, React.CSSProperties> = {
    warning: { color: palette.warning, background: 'transparent' },
    primary: { color: onboardColors.surface.white, background: palette.teal },
    neutral: {
      color: palette.bodyNeutral,
      background: onboardColors.surface.white,
      border: `1px solid ${palette.divider}`
    },
    icon: { color: palette.bodyNeutral, background: 'transparent', padding: 4 }
  };

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      title={title}
      type={type === 'submit' ? 'submit' : 'button'}
      style={{
        ...palettes[variant],
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        fontFamily: font,
        fontWeight: 700,
        fontSize: variant === 'primary' ? 14 : 12,
        padding: variant === 'icon' ? 4 : '8px 16px',
        border: palettes[variant].border ?? 'none',
        borderRadius: 6,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        ...style
      }}
    >
      {icon}
      {label}
    </button>
  );
};

export default ActionButton;
